import { useEffect, useState } from 'react'

import { getClientLocation } from '@/helpers/getClientLocation'
import { getStateAbbreviation } from '@/helpers/getStateAbbreviation'

export const useGetClientLocation = () => {
  const [location, setLocation] = useState<string | undefined>()

  useEffect(() => {
    const getLocation = async () => {
      const location = await getClientLocation()
      const region = location?.region
        ? getStateAbbreviation(location.region)
        : undefined

      setLocation(region)
    }
    getLocation()
  }, [])

  return location
}
